import React from 'react';
/*import Map from './Map';
import credentials from '../../../credentials/credentials';
const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credentials.mapsKey}`;
*/
import mapRefrigoExample from '../../../assets/mapRefrigoexample.png';




const ContactoMap = (props) => {
  return (

    <div className="contenedor-direccion">
      <h3>Contactanos</h3>
      <span>Telefonos: <strong>+54 9 11 25531022</strong></span>
      {<br></br>}
      <span>Email: <strong>Refrigoar@gmail.com</strong></span>
      {<br></br>}
      <span>Direccion: Buenos Aires, Argentina</span>
      {<br></br>}
      <div className="container_googleMaps">
      </div>
{/* 

<React.Fragment>
        <Map
          googleMapURL={mapURL}
          containerElement={<div className="containerElement" />}
          mapElement={<div className="mapElement" />}
          loadingElement={<p>Cargando</p>}
        />
      </React.Fragment>

*/}
      <div>
        <img src={mapRefrigoExample} alt="mapa" className="mapaRefrigoExample"/>
      </div>
    </div >

  )
}

export default ContactoMap;